export default "__VITE_ASSET__DNLAe3uD__"